export default __webpack_public_path__ + "static/media/bronze.86451b3b.svg";